export default [
  {
    reducerKey: 'bank-cards/cards',
    sagaKey: 'bankCardsListSaga',
    importReducer: () =>
      import(/* webpackChunkName: "domain-bank-cards" */ 'modules/BankCards/List/store/reducer'),
    importSaga: () =>
      import(/* webpackChunkName: "domain-bank-cards" */ 'modules/BankCards/List/store/saga'),
  },
  {
    reducerKey: 'bank-cards/card',
    sagaKey: 'bankCardsCardSaga',
    importReducer: () =>
      import(/* webpackChunkName: "domain-bank-cards" */ 'modules/BankCards/Card/store/reducer'),
    importSaga: () =>
      import(/* webpackChunkName: "domain-bank-cards" */ 'modules/BankCards/Card/store/saga'),
  },
]
